
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Volvobusonrentinpune() {



    const cardData =
    {
        keyword: 'Volvo Bus On Rent in Pune',
        heading: 'Amruta Travels: Volvo Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers Volvo Bus on Rent in Pune, providing a luxurious and comfortable transportation solution for your travel needs. Whether you are planning a corporate event, family trip, wedding, or group tour, our well-maintained Volvo buses ensure a smooth and enjoyable journey. Choose from our range of Volvo buses, including 35-seater, 40-seater, and 45-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your travel in and around Pune simple and stress-free. Book your Volvo bus with Amruta Travels and experience a journey of luxury and comfort!',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description": "Located approximately 66 km from Pune, these twin hill stations are nestled in the Sahyadri ranges. Known for their lush green valleys, waterfalls, and pleasant climate, they offer attractions like Bhushi Dam, Tiger's Leap, and Rajmachi Fort. Adventure enthusiasts can indulge in trekking, camping, and paragliding activities."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description": "Situated about 120 km from Pune, Mahabaleshwar is renowned for its strawberry farms, scenic viewpoints like Arthur's Seat, and the serene Venna Lake. Nearby Panchgani, at a distance of 100 km, offers attractions like Table Land and Parsi Point. Both hill stations provide a refreshing escape from city life."
  },
  {
    "title": "Matheran",
    "description": "Approximately 120 km from Pune, Matheran is India's smallest hill station and is unique for being a vehicle-free zone. Perched at an elevation of 800 meters, it offers panoramic views, colonial architecture, and 38 designated viewpoints, including Panorama Point and Louisa Point."
  },
  {
    "title": "Alibaug",
    "description": "Located around 140 km from Pune, Alibaug is a coastal town known for its clean beaches like Alibaug Beach and Nagaon Beach, as well as historical sites like Kolaba Fort. It's a popular destination for beach lovers and those seeking a tranquil seaside retreat."
  },
  {
    "title": "Kolad",
    "description": "Approximately 110 km from Pune, Kolad is famed for white-water rafting on the Kundalika River. The town also offers opportunities for kayaking, zip-lining, and camping, making it a haven for adventure seekers."
  },
  {
    "title": "Igatpuri",
    "description": "Situated about 240 km from Pune, Igatpuri is a hill station in the Western Ghats known for its misty mountains, waterfalls, and the Vipassana International Academy. It's an ideal spot for meditation, trekking, and enjoying nature's tranquility."
  },
  {
    "title": "Bhandardara",
    "description": "Located roughly 170 km from Pune, Bhandardara is a serene village offering attractions like the Bhandardara Lake, Randha Falls, and the historic Ratangad Fort. It's a perfect destination for nature lovers and those seeking solitude."
  },
  {
    "title": "Lavasa",
    "description": "Approximately 60 km from Pune, Lavasa is a planned city inspired by the Italian town of Portofino. It offers picturesque landscapes, water sports, and a range of dining options, making it a popular spot for weekend retreats."
  },
  {
    "title": "Goa",
    "description": "Situated about 450 km from Pune, Goa is India's premier beach destination. Known for its vibrant nightlife, Portuguese heritage, and sandy beaches like Baga and Anjuna, it offers a mix of relaxation and entertainment."
  },
  {
    "title": "Kaas Plateau",
    "description": "Around 140 km from Pune, the Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' is a UNESCO World Natural Heritage site. During the monsoon season, it blooms with a variety of endemic flowers, attracting nature enthusiasts and photographers."
  }
],


  "services": [
    {
      "name": "Volvo Sleeper Bus Rent Per Km",
      "description": "Amruta Travels offers Volvo sleeper buses on a per kilometer rental basis. Ideal for long-distance and overnight journeys, these buses provide maximum comfort with reclining sleeper berths, air-conditioning, and onboard amenities. Transparent pricing ensures affordability and convenience for group travel."
    },
    {
      "name": "Volvo Bus Hire in Pune Near Me",
      "description": "Looking for a Volvo bus near your location in Pune? Amruta Travels provides easy and reliable Volvo bus hire services across Pune, including all major areas. Enjoy luxury, safety, and timely service for family trips, corporate outings, or weekend getaways."
    },
    {
      "name": "Sleeper Bus on Rent in Pune",
      "description": "Travel overnight in comfort with Amruta Travels’ sleeper buses available on rent in Pune. These buses are designed for restful travel on long routes, perfect for spiritual yatras, corporate events, or outstation tours, accommodating large groups with ease."
    },
    {
      "name": "Top AC Sleeper Bus on Rent in Pune",
      "description": "Experience premium travel with our top-rated AC sleeper buses on rent in Pune. Fully air-conditioned, with spacious sleeping berths and luxury interiors, these buses are perfect for multi-day tours or night journeys for families, corporates, or pilgrim groups."
    },
    {
      "name": "AC Sleeper Bus Rental Service",
      "description": "Amruta Travels offers high-quality AC sleeper bus rental services in Pune. Whether it’s a pilgrimage tour, vacation, or corporate trip, our sleeper buses are equipped with modern features, clean interiors, and professional drivers for a comfortable journey."
    },
    {
      "name": "AC 50 Seater Bus Sleeper on Rent",
      "description": "For large groups, our 50-seater AC sleeper buses provide the perfect solution. Available on rent for long tours or overnight journeys from Pune, these buses offer sleeping berths, AC comfort, and a safe and smooth ride for all passengers."
    },
    {
      "name": "Volvo Bus on Rent in Pune",
      "description": "Hire a Volvo bus in Pune with Amruta Travels for premium group travel. Our Volvo buses feature modern amenities like reclining seats, air conditioning, entertainment systems, and a professional chauffeur service, ideal for business or leisure travel."
    },
    {
      "name": "Volvo Bus on Rent in Pune for Family",
      "description": "Planning a family trip? Amruta Travels offers Volvo buses on rent for family travel in and around Pune. These buses ensure comfort, safety, and enough space for all family members, making long journeys enjoyable and hassle-free."
    },
    {
      "name": "Hire Luxury Bus on Rent",
      "description": "Choose Amruta Travels for luxury bus rental services in Pune. Our fleet includes high-end buses equipped with modern interiors, comfortable seating, air conditioning, and entertainment options, suitable for weddings, corporate events, or long tours."
    },
    {
      "name": "Hire Luxury Bus on Rent Near Me in Pimpri Chinchwad",
      "description": "Amruta Travels offers luxury buses for rent near Pimpri Chinchwad. With high-quality interiors, experienced drivers, and top-rated service, our buses are perfect for weddings, outings, or family trips originating from the PCMC area."
    },
    {
      "name": "Luxury Bus on Rent in Pune",
      "description": "Amruta Travels provides premium luxury buses on rent across Pune for both corporate and personal travel. Enjoy spacious interiors, top-notch comfort, and smooth journeys, whether it’s a weekend tour, outstation trip, or special event."
    },
    {
      "name": "Volvo Bus on Rent for Picnic",
      "description": "Enjoy a relaxing and stylish picnic with our Volvo bus rental service in Pune. These buses are perfect for day or weekend getaways, offering comfortable seating, air conditioning, and entertainment for a joyful group travel experience."
    },
    {
      "name": "Volvo Bus on Rent for Corporate Event",
      "description": "Make your corporate event travel seamless with Volvo buses from Amruta Travels. Our corporate rental service ensures professional coordination, comfort, and timely service, suitable for employee outings, conferences, or business meets."
    },
    {
      "name": "Volvo Bus on Rent for Corporate Picnic",
      "description": "Plan your next corporate picnic with ease using our Volvo bus rental service. Spacious, air-conditioned, and comfortable, our buses ensure your team arrives relaxed and ready for a fun-filled day outside the office."
    },
    {
      "name": "Volvo Bus on Rent for Ashtavinayak Darshan",
      "description": "Take a comfortable and spiritual journey across the eight Ashtavinayak temples with a Volvo bus rental from Amruta Travels. Our buses offer ample space, luxury interiors, and smooth service to make your pilgrimage memorable and peaceful."
    },
    {
      "name": "Volvo Bus on Rent for 12 Jyotirlinga Darshan",
      "description": "For those seeking a spiritual adventure, Amruta Travels offers Volvo buses on rent for the 12 Jyotirlinga Darshan tour. Travel across India in luxury and comfort with our sleeper Volvo buses, ensuring safety, comfort, and divine experience."
    }
  ],
  "tableData": [
    ["Volvo Sleeper Bus Rent Per Km", "Volvo Bus Hire in Pune Near Me"],
    ["Sleeper Bus on Rent in Pune", "Top AC Sleeper Bus on Rent in Pune"],
    ["AC Sleeper Bus Rental Service", "AC 50 Seater Bus Sleeper on Rent"],
    ["Volvo Bus on Rent in Pune", "Volvo Bus on Rent in Pune for Family"],
    ["Hire Luxury Bus on Rent", "Hire Luxury Bus on Rent Near Me in Pimpri Chinchwad"],
    ["Luxury Bus on Rent in Pune", "Volvo Bus on Rent for Picnic"],
    ["Volvo Bus on Rent for Corporate Event", "Volvo Bus on Rent for Corporate Picnic"],
    ["Volvo Bus on Rent for Ashtavinayak Darshan", "Volvo Bus on Rent for 12 Jyotirlinga Darshan"]
  ],





"whychoose": [
  {
    "WhyChooseheading": "Luxury Volvo Bus Rental in Pune for All Group Travel Needs",
    "WhyChoosedescription": "Amruta Travels offers top-tier Volvo bus rental services in Pune, perfect for long-distance travel, corporate tours, weddings, and VIP group transportation. Our Volvo buses are known for their unmatched comfort, advanced suspension, and plush interiors, delivering a premium travel experience for groups seeking luxury, reliability, and professionalism on the road."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Events, Weddings, and Outstation Tours",
    "WhyChoosedescription": "Whether it's transporting corporate teams to off-site events, handling guest transfers during weddings, or planning a multi-day outstation tour to destinations like Goa, Mahabaleshwar, or Shirdi, our Volvo buses are the ideal choice. They offer elegance, space, and convenience while maintaining a high standard of service for both business and leisure travel."
  },
  {
    "WhyChooseheading": "Premium Seating and Onboard Comfort for Long Journeys",
    "WhyChoosedescription": "Our Volvo buses come equipped with ergonomically designed push-back seats, individual AC vents, reading lights, entertainment systems, and smooth air suspension that minimizes travel fatigue. Whether you're traveling overnight or across states, the Volvo experience guarantees maximum comfort for every passenger throughout the journey."
  },
  {
    "WhyChooseheading": "Highly Maintained Fleet with Modern Amenities",
    "WhyChoosedescription": "Each Volvo bus in our fleet is regularly maintained, fully sanitized, and equipped with modern features such as onboard entertainment, charging points, large luggage storage, curtains for privacy, and tinted windows. We ensure a clean, safe, and refined environment for travelers, every time."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs for Seamless Travel",
    "WhyChoosedescription": "Our Volvo buses are driven by professional, uniformed drivers who are well-versed in handling luxury vehicles and long-distance travel. They ensure punctuality, safe driving practices, and a polite, helpful attitude that enhances the overall travel experience for your group."
  },
  {
    "WhyChooseheading": "Customizable Routes and Schedules from Pune",
    "WhyChoosedescription": "Amruta Travels allows full customization of your trip. Whether it’s multiple pickup/drop locations in Pune or a customized route covering different cities, our Volvo services are flexible enough to match your schedule. We help with itinerary planning, stopover arrangements, and trip coordination to ensure smooth execution."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Volvo Bus Pricing",
    "WhyChoosedescription": "We offer Volvo bus rentals in Pune at competitive rates with complete transparency. Our pricing includes fuel, tolls, driver allowances, and taxes—no hidden charges. We also provide custom quotations for weddings, corporate events, and outstation tours based on your specific itinerary and requirements."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Customer Support",
    "WhyChoosedescription": "Booking a Volvo bus with Amruta Travels is quick and simple. Our support team is available round the clock to help you choose the right bus, plan your trip, and offer assistance throughout your journey. Whether it's a last-minute booking or a planned luxury tour, we’re here to support you at every step."
  }
]














    }

const faqData = [
  {
    question: 'Can I rent a Volvo bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers premium Volvo buses for rent in Pune. Ideal for long-distance travel, corporate trips, weddings, and luxury tours, our Volvo buses provide a first-class travel experience.',
  },
  {
    question: 'What are the features of the Volvo buses available for rent?',
    answer: 'Our Volvo buses are equipped with push-back reclining seats, air suspension, full air conditioning, ample legroom, large luggage compartments, and entertainment systems for a smooth and luxurious ride.',
  },
  {
    question: 'What seating capacities are available for Volvo buses?',
    answer: 'We offer Volvo buses with seating capacities ranging from 35 to 50 passengers, suitable for both mid-size and large groups.',
  },
  {
    question: 'Is the Volvo bus rental service available for outstation trips?',
    answer: 'Yes, our Volvo buses are perfect for outstation journeys from Pune including trips to Mumbai, Goa, Mahabaleshwar, Shirdi, Bangalore, Hyderabad, and more.',
  },
  {
    question: 'Do you provide drivers with Volvo bus rentals?',
    answer: 'Absolutely. All our Volvo buses come with professional, licensed drivers experienced in handling long-distance and luxury travel.',
  },
  {
    question: 'Is the Volvo bus suitable for corporate or VIP events?',
    answer: 'Yes, our Volvo buses are often booked for corporate transfers, VIP events, airport pickups, and executive tours due to their comfort and presentation.',
  },
  {
    question: 'Can the Volvo bus be used for wedding guest transport?',
    answer: 'Definitely! Volvo buses are an excellent choice for transporting wedding guests in comfort and style, with a professional and timely service.',
  },
  {
    question: 'How much does it cost to rent a Volvo bus in Pune?',
    answer: 'The rental cost depends on trip duration, distance, bus capacity, and services needed. Contact us with your travel details for a transparent and customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for Volvo bus rentals in Pune?',
    answer: 'Amruta Travels is known for high-quality service, clean and well-maintained Volvo buses, trained staff, and seamless booking. We focus on luxury, safety, and satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Harshal Mehta',
    role: 'Corporate Travel Coordinator',
    text: 'We hired a Volvo bus from Amruta Travels for a corporate conference in Mumbai. The bus was luxurious, punctual, and the ride was extremely smooth. Excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Wagh',
    role: 'Wedding Planner, Pune',
    text: 'The Volvo bus rental for our wedding guests was a great decision. The guests loved the comfort and the professional service by Amruta Travels. Highly recommended!',
    rating: 5,
  },
];






































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/volvo-bus-rent-pune.jpg",
  "description": "Rent a Volvo sleeper bus in Pune for a luxury travel experience. Choose from 50-seater and AC sleeper buses for corporate events, picnics, or family trips. Amruta Travels offers top-class Volvo buses for a comfortable and affordable journey, available for both short and long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "12500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/volvo-bus-on-rent-in-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Volvo Bus on Rent in Pune | Luxury AC Sleeper Bus Rentals | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire a luxury Volvo AC sleeper bus for your next trip in Pune. Available for corporate events, picnics, family trips, and more. Comfortable 50-seater buses on rent in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Volvobusonrentinpune;